import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { map,filter, pluck  } from "rxjs/operators";
import { FiltrosLiquidaciones } from 'app/models/FiltrosLiquidaciones';
import { Observable } from 'rxjs';
import { SessionStorageService } from '../storage/sessionStorage.service';
import { LocalService } from '../storage/localService';
@Injectable({
  providedIn: 'root'
})
export class LiquidacionService {

  readonly urlBase =  environment.rutaBase;
  header : HttpHeaders;
  datos:any = [];
  dataLiquidacion:any;
  arrayLiquidacion:any;
  proveedorCorreo:any;
  addContactoLiquidacion:boolean
  message: Observable<any>;
  idEmpresa_Factor : any;
  arrayLiquidacionResumen:any;
  detalleLiquidacion:any;
  
  constructor(private http: HttpClient,
              private accesoService :AccesoService, private sessionStorageService: SessionStorageService,
              private localService : LocalService) { 
  this.header = this.accesoService.desencriptarTOKEN();
  this.datoStorage();
  }

  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }

  obtenerLiquidaciones(data:FiltrosLiquidaciones){  
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/liquidacion?idEmpresa_Factor=${this.idEmpresa_Factor}&idProveedor=${data.IdProv}&idAdquirente=${data.IdAdq}&moneda=${data.Moneda}&estado=${data.Estado}&fechaInicial=${data.FechaIni}&fechaFinal=${data.FechaFin}`,{headers});
  }

  obtenerLiquidacionesDetalle(idLiquidacion){  
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/liquidacion/${idLiquidacion}?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  obtenerLiquidacion(id){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/liquidacion/${id}?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  obtenerDocumentosPagados(){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/liquidacion/documentos?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  crearLiquidacion(data: any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/liquidacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }


  obtenerLiquidacionesPorGrupo(){
    
    let headers = this.header;
    return this.http.get(`${this.urlBase}/liquidaciones/grupos?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
  }

  obtenerLiquidacionesPoriD(data){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/liquidacionResumen?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
  }

  crearLiquidacionResumen(data: any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/liquidaciones?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  obtenerResumenLiquidaciones(data: any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/liquidaciones?idEmpresa_Factor=${this.idEmpresa_Factor}&idProveedor=${data.idProvFilter}&idAdquirente=${data.idAdqFilter}&moneda=${data.monedaFilter}&estado=${data.estadoFilter}&fechaInicial=${data.fromDate}&fechaFinal=${data.toDate}`,{headers});
  }

  FiltroListadoLiquidacion(Filtro:FiltrosLiquidaciones){
    let headers = this.header;
    return this.http.get(
      `${this.urlBase}/liquidacion?idEmpresa_Factor=${this.idEmpresa_Factor}&IdProveedor=${Filtro.IdProv}&Estado=${Filtro.Estado}&FechaInicial=${Filtro.FechaIni}&FechaFinal=${Filtro.FechaFin}&Moneda=${Filtro.Moneda}`,{headers});      
  }
  
  ObtenerLiquidacionDesembolso(Filtro:FiltrosLiquidaciones){
    Filtro.FechaIni = "2020-01-01";
    Filtro.FechaFin = "2021-04-08"
    let headers = this.header;
    return this.http.get(
      `${this.urlBase}/LiquidacionDesembolso?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&idProveedor=${Filtro.IdProv}&FechaInicial=${Filtro.FechaIni}&FechaFinal=${Filtro.FechaFin}&Moneda=${Filtro.Moneda}&Estado=${Filtro.Estado}`,{headers}
    )
    .pipe(
      map((data) => {
        this.datos = data;         
        return data;
      })
    );
  }

  EnviarCorreoPlanillaLiquidacion(data : any){
    let headers = this.header; 
    return this.http
      .post(`${this.urlBase}/mailResumen?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  bajaEstadoLiquidacion(body:any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/liquidacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  }

  actualizarEstadoLiquidacion(body:any, idLiquidacion? :any){    
    let headers = this.header;
    return this.http.put(`${this.urlBase}/ActualizarLiquidacion?idEmpresa_Factor=${this.idEmpresa_Factor}&idLiquidacion=${idLiquidacion}`,body,{headers})
  }

  bajaResumen(idResumenLiquidacion,canal,usuario){    
    let headers = this.header;
    return this.http.delete(`${this.urlBase}/liquidaciones?idEmpresa_Factor=${this.idEmpresa_Factor}&idResumen_Liquidaciones=${idResumenLiquidacion}&canal=${canal}&usuario=${usuario}`,{headers})
  }

  confirmarResumen(body){    
    let headers = this.header;
    return this.http.put(`${this.urlBase}/liquidaciones?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  }

}
